var _animate, _path, _animate2, _animate3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlug(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 210.9 375.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M105.45,327.09c6.55,0-24.71-.16-58.57-2.54-31.29-2.2-38.24-21.05-40.4-34.31C-3.1,231.4.42,117.24,6,45.76,7.46,12.7,26.71,7.11,42.55,4.25,58.62,1.36,105.45.5,105.45.5s46.83.86,62.9,3.75c15.84,2.86,35.09,8.45,36.54,41.51,5.59,71.48,9.11,185.64-.47,244.48-2.16,13.26-9.11,32.11-40.41,34.31C130.16,326.93,98.9,327.09,105.45,327.09Z",
    style: {
      fill: "#fff",
      stroke: "#676767",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.82,324.86s-1.95-3.12-5.44-8.46-4.27-5.86-7.7-5.86c0,0-25.84,2.74-45.23,2.74s-45.24-2.74-45.24-2.74c-3.42,0-4.2.53-7.69,5.86s-5.44,8.46-5.44,8.46,47.66,2.32,58.37,2.23S163.82,324.86,163.82,324.86Z",
    style: {
      fill: "#777777",
      stroke: "#676767",
      strokeMiterlimit: 10
    }
  }, _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    id: "hinava_random_uuid_plug_blink",
    attributeName: "fill",
    values: "#777777;#ffffff;#777777",
    begin: "hinava_random_uuid_plug_hand_out.end",
    end: "hinava_random_uuid_plug_hand_out.end+4.2s;",
    dur: "0.7s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M105.45,327.09c6.55,0-24.71-.16-58.57-2.54-31.29-2.2-38.24-21.05-40.4-34.31C-3.1,231.4.42,117.24,6,45.76,7.46,12.7,26.71,7.11,42.55,4.25,58.62,1.36,105.45.5,105.45.5s46.83.86,62.9,3.75c15.84,2.86,35.09,8.45,36.54,41.51,5.59,71.48,9.11,185.64-.47,244.48-2.16,13.26-9.11,32.11-40.41,34.31C130.16,326.93,98.9,327.09,105.45,327.09Z",
    style: {
      fill: "none",
      stroke: "#676767",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.45,
    cy: 103.52,
    r: 82.85,
    style: {
      fill: "none",
      stroke: "#676767",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.45,
    cy: 103.52,
    r: 69.69,
    style: {
      fill: "none",
      stroke: "#676767",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.45,
    cy: 103.52,
    r: 63.83,
    style: {
      fill: "none",
      stroke: "#676767",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.41,
    cy: 103.52,
    r: 9.54,
    style: {
      fill: "none",
      stroke: "#676767",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.49,
    cy: 103.52,
    r: 9.54,
    style: {
      fill: "none",
      stroke: "#676767",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.14,40.44V52.52a4.14,4.14,0,0,1-4.31,3.91h-8.77a4.13,4.13,0,0,1-4.3-3.91V40.44",
    style: {
      fill: "none",
      stroke: "#676767",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.14,167.35V155.27a4.14,4.14,0,0,0-4.31-3.91h-8.77a4.13,4.13,0,0,0-4.3,3.91v12.08",
    style: {
      fill: "none",
      stroke: "#676767",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.45,
    y1: 186.36,
    x2: 105.45,
    y2: 312.84,
    style: {
      fill: "none",
      stroke: "#676767",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.45,
    y1: 0.5,
    x2: 105.45,
    y2: 20.67,
    style: {
      fill: "none",
      stroke: "#676767",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.41,231.54A24.17,24.17,0,0,0,80.33,254a14.06,14.06,0,0,1,12.82-7.57,14.86,14.86,0,0,1,8.95,2.91,14.19,14.19,0,0,1,3.54-5.36,14.77,14.77,0,0,1,10.2-4,14.25,14.25,0,0,1,9.34,3.42A24.15,24.15,0,0,0,104.41,231.54Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.7,311.42c-2-12.05-10.41-13.6-14.54-13.6l-.39,0h-.08a3.08,3.08,0,0,1-2.79-1.49c-2.77-5.15-7.26-5.62-10.62-5.62-.18,0-.35.35-.53.35h0c-1.41,0-3.65-1.79-3.65-3.21V254.59a8.46,8.46,0,0,0-16.92-.37v33.31c0,1.65-.13,3.5-1.77,3.5h-.05a3.14,3.14,0,0,1-2.92-3.17V260.64c0-5.33-4.13-8.06-8.26-8.06s-8.25,2.63-8.25,8l0,41.28c0,3.52-3.64,5.69-7.14,5.69a6.22,6.22,0,0,1-5.36-2.6l-.57-.89a7.58,7.58,0,0,0-6.6-4c-5.49,0-10.86,5.85-7.16,12.14a.94.94,0,0,1,.12.22L88.57,368a3.67,3.67,0,0,0,3,2.23l42,.34h0a3.66,3.66,0,0,0,3.3-3L141,354.8a3.85,3.85,0,0,1,.49-1.27C153.27,335.69,157.65,323.11,155.7,311.42Z",
    style: {
      fill: "#fcd3c5"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.57,295c-3.62-2.39-8.49-3.11-11.36-3.25-2.18-3.24-6.31-6.51-13.08-7.31V254.59c0-4.55-.9-8.54-4-11.21a12.91,12.91,0,0,0-8.82-3.42,14.15,14.15,0,0,0-9.94,4,13.87,13.87,0,0,0-3.41,5.36,14.68,14.68,0,0,0-8.88-2.91A13.8,13.8,0,0,0,80.44,254a14.34,14.34,0,0,0-1.36,6.51v11.22l-.15,29.47a3.08,3.08,0,0,1-1.12.22,2,2,0,0,1-.42,0l-.41-.6A13.67,13.67,0,0,0,65.22,294a14.84,14.84,0,0,0-12.69,7.37,13.57,13.57,0,0,0,.22,13.85,1.09,1.09,0,0,1,.08.15l30.34,55.41A9.49,9.49,0,0,0,91.6,376l42,0a9.47,9.47,0,0,0,9.17-7.14l4.1-12.26a.75.75,0,0,1,.05-.16c12.57-19.2,17-33,14.83-46C160.25,301.71,155.93,297.25,152.57,295ZM141,354.65l-4.19,12.85a3.66,3.66,0,0,1-3.3,3h0l-42-.34a3.5,3.5,0,0,1-3-2.07l-30.4-55.6a1.23,1.23,0,0,0-.12-.26c-3.7-6.29,1.67-12.16,7.16-12.16a7.57,7.57,0,0,1,6.6,4l.57.88a6.21,6.21,0,0,0,5.36,2.59c3.5,0,7.13-2.17,7.14-5.69l0-41.3c0-5.34,4.13-8,8.25-8s8.26,2.67,8.26,8v27.34a3.14,3.14,0,0,0,2.92,3.17h.05c1.64,0,1.77-1.85,1.77-3.5V254.22a8.46,8.46,0,0,1,16.92.37v33.23c0,1.42,2.24,3.21,3.65,3.21h.05c.18,0,.35-.33.53-.33,3.35,0,7.85.64,10.61,5.79a3,3,0,0,0,2.79,1.44s.05,0,.08,0l.39,0c4.13,0,12.52,1.51,14.54,13.56,2,11.69-2.43,24.18-14.17,42A3.57,3.57,0,0,0,141,354.65Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.7,207.5V250a11.25,11.25,0,0,0-3.6-6.6,13.64,13.64,0,0,0-1.4-1.11V212.5H88.3v34.76a13.66,13.66,0,0,0-5,3.05V207.5Z",
    style: {
      fill: "#f26850"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.7,218.7v21.52a13.82,13.82,0,0,0-2.4-.22,14,14,0,0,0-9.9,4,13.8,13.8,0,0,0-3.4,5.4,15,15,0,0,0-8.7-2.9V218.7Z",
    style: {
      fill: "#f26850"
    }
  }), _animate2 || (_animate2 = /*#__PURE__*/React.createElement("animate", {
    id: "hinava_random_uuid_plug_hand_in",
    attributeName: "fill-opacity",
    from: 0,
    to: 1,
    begin: "0.5s;hinava_random_uuid_plug_blink.end+1s",
    dur: "1.5s",
    fill: "freeze"
  })), _animate3 || (_animate3 = /*#__PURE__*/React.createElement("animate", {
    id: "hinava_random_uuid_plug_hand_out",
    attributeName: "fill-opacity",
    from: 1,
    to: 0,
    begin: "hinava_random_uuid_plug_hand_in.end+1s",
    dur: "1s",
    fill: "freeze"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlug);
export default __webpack_public_path__ + "static/media/plug.b88857bba85eceab62873696d2dd896f.svg";
export { ForwardRef as ReactComponent };